var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"seller"},[_c('el-header',{staticClass:"seller-layout-header"},[_c('sellerHeader')],1),_vm._v(" "),_c('el-container',{staticClass:"seller-layout-container"},[_c('el-aside',{staticClass:"seller-layout-left"},[_c('sellerLeftNav')],1),_vm._v(" "),_c('el-main',{staticClass:"seller-layout-main"},[_c('sellerMain')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-849d8d9e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/index.vue
// module id = null
// module chunks = 